import {asset} from 'imba';
import url from './churchsoutheast.jpg';
export default asset({
	url: url,
	type: 'image',
	width: 1079,
	height: 1079,
	toString: function(){ return this.url;}
})